import { formatUTCDate, createDownloadableLink } from '@/helpers';
import { FORMAT_DD_MM_YYYY } from '@/module/company/constants';
import moment from 'moment';
import { synthesize } from 'redux-dispatcher';

// NOTE: The endpoints below are PLACEHOLDERS following the Lab E-order naming
// convention (patient-appointments/innoquest-orders/...). Replace the paths
// once the real AgeQ report API is provided by the backend.
const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),
  resetData: () => ({}),
  setState: (state, value) => ({ state, value }),
  getDataAgeQReport:
    (paging, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().ageqReport.paging;
      const { startDate, endDate, ...restFilter } = filterOption || {};
      let { result, status } = await Api.post(
        `pax-screenings/ageq-test-results/filter`,
        {
          pageIndex: pagingData.pageIndex,
          pageSize: pagingData.pageSize,
          ...restFilter,
          fromDate: startDate
            ? formatUTCDate(startDate, { isStarOfDay: true })
            : undefined,
          toDate: endDate
            ? formatUTCDate(endDate, { isEndOfDay: true })
            : undefined,
        }
      );
      status === 200 && ageqReportDispatcher.getDataSuccess(result);
    },
  exportAgeQReport:
    (params) =>
    async ({ Api }) => {
      const { startDate, endDate, ...rest } = params || {};
      const { status, result } = await Api.post(
        `pax-screenings/exports/ageq-test-results`,
        {
          ...rest,
          fromDate: startDate
            ? formatUTCDate(startDate, { isStarOfDay: true })
            : undefined,
          toDate: endDate
            ? formatUTCDate(endDate, { isEndOfDay: true })
            : undefined,
        }
      );
      const fileName = `AgeQ_Report_${moment().format(FORMAT_DD_MM_YYYY)}`;
      status === 200 && createDownloadableLink(result, fileName);
    },
};

const ageqReportDispatcher = synthesize('ageqReport', mapDispatchToAC);

export default ageqReportDispatcher;
